/**
 * FAQ-contact — accordion (SINGLE-open).
 *
 * Dunne wrapper op de gedeelde accordion-module (resources/js/accordion.js): dit
 * blok levert z'n eigen .faq-contact__* selectors en het SINGLE-open-gedrag (max
 * één item tegelijk open; opnieuw klikken sluit het). Import in
 * resources/js/main.js; self-init op DOM-ready. De height-animatie + de
 * visibility-fix (gesloten paneel uit de tab-volgorde) zitten in de blok-scss.
 */
import { initAccordion } from '../../resources/js/accordion.js';

const CONFIG = {
    block: '.faq-contact',
    item: '.faq-contact__item',
    button: '.faq-contact__question',
    openClass: 'faq-contact__item--open',
    singleOpen: true,
};

/**
 * Initialiseert alle faq-contact-blokken binnen een scope.
 *
 * @param {ParentNode} [scope] - Zoekwortel (default: document).
 */
export function initFaqContact(scope = document) {
    initAccordion(CONFIG, scope);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFaqContact());
} else {
    initFaqContact();
}
